<template>
  <div id="app">
    <router-view />
    <!-- <router-view style="border:2px green solid" name="zzgl_grycx"/> -->
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
.width-1200-auto {
  width: 1200px;
  margin: 0 auto;
  margin-left: calc(50% - 600px);
}
body /deep/ .ivu-modal-confirm-head {
  text-align: left;
  margin-bottom: 10px;
}
body /deep/ .ivu-modal-confirm-body {
  padding-left: 0;
}
.cofirm-txt {
  font-size: 17px;
  color: black;
}
body /deep/ .ivu-modal-confirm-footer .ivu-btn.ivu-btn-text {
  border: 1px solid #dcdee2;
}
body /deep/ .ivu-modal-body {
  padding: 10px;
}
.home-chart-table {
  border-left: 1px solid #e8eaec;
  border-top: 1px solid #e8eaec;
  margin: 10px;
  width: calc(100% - 21px);
  line-height: 30px;
  background: white;
}
.home-chart-table th {
  background: #f8f8f9;
}
.home-chart-table td,
.home-chart-table th {
  border-right: 1px solid #e8eaec;
  border-bottom: 1px solid #e8eaec;
  padding: 4px 12px;
}
.table-form-item {
  width: 90%;
  margin: 2px 0;
}
.table-form-item /deep/ .ivu-input,
.table-form-item /deep/ .ivu-select-selection {
  border: none;
  background: transparent;
}
.text-c .table-form-item /deep/ .ivu-input {
  text-align: center;
}
.home-chart-table .text-l /deep/ .ivu-input {
  text-align: left;
}
.page-modal /deep/ .ivu-modal-header {
  border-left: #199ed8 solid 4px;
  text-align: left;
  font-weight: bold;
}
.page-table {
  border-left: none;
  margin: 0;
  width: 100%;
}
.page-table tr td:last-child {
  border-right: none;
}
.page-table td,
.page-table th {
  padding: 6px 0;
}
.page-table tr:nth-child(2n-1) {
  background: #f8f8f9;
}
.page-table tr:hover {
  background: #ebf7ff;
}

.page-table tr /deep/ .ivu-input {
  background: transparent;
}
.header-nav-box {
  width: calc(100% - 600px);
  height: 100%;
  padding: 0 30px;
  line-height: 60px;
  font-size: 18px;
  display: inline-block;
}
.header-nav {
  display: flex;
  height: 100%;
  max-width: 1050px;
  margin: 0 auto;
}
.header-nav-item {
  flex: 1;
  text-align: center;
  padding: 0 10px;
}
.header-nav-item a {
  color: white;
}
.header-nav-item.active {
  background: #1c5db9;
}
.page-nav {
  height: 70px;
  background: #f3f8fa;
  line-height: 70px;
  text-align: left;
}
.page-nav-title {
  font-size: 28px;
  font-weight: 300;

  font-family: "Roboto", sans-serif;
}

.portfolio-filters {
  margin: 30px 0 10px 0;
}
.portfolio-filters .filter {
  border: 2px solid #86989d;
  color: #86989d;
  display: inline-block;
  font-family: pt sans;
  margin: 3px;
  padding: 5px 15px;
  text-transform: uppercase;
  cursor: pointer;
  letter-spacing: 2px;
}
.portfolio-filters .filter.active {
  background: #86989d;
  color: #fff;
}
.portfolio-filters .filter:hover {
  opacity: 0.9;
  background: #86989d;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue